export default __webpack_public_path__ + "static/media/link.d6080dfb.svg";